import { BasePornCategory } from '@api/backend';
import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { ErrorResponse } from '@core/models';
import { computed, inject } from '@angular/core';
import { PornRepository } from '@core/repositories/porn.repository';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, distinctUntilChanged, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

type CategoryState = {
  list: Array<BasePornCategory>
  isLoading: boolean;
  error: ErrorResponse | null
};

const initialCategoryState: CategoryState = {
  list: [],
  isLoading: false,
  error: null,
};

export const CategoryStore = signalStore(
  { providedIn: 'root' },
  withState(initialCategoryState),
  withMethods((state, api = inject(PornRepository)) => ({
    load: rxMethod<void>(
      pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap(() => api.getCategories().pipe(
          tapResponse({
            next: (response) => patchState(state, { list: response.data }),
            error: () => {},
            finalize: () => patchState(state, { isLoading: false }),
          }),
        )),
      ),
    ),
  })),
  withComputed(({ list }) => {
    return {
      topList: computed(() => {
        return ([].slice.call(list()) as BasePornCategory[])
          .sort((a, b) => b.count - a.count).slice(0, 10);
      }),
      anotherList: computed(() => {
        const top = ([].slice.call(list()) as BasePornCategory[])
          .sort((a, b) => b.count - a.count).slice(0, 10);
        return ([].slice.call(list()) as BasePornCategory[])
          .filter(category => top.every(item => item.category !== category.category));
      }),
    };
  }),
  withComputed((store) => {
    return {
      anotherList: computed(() => {
        return ([].slice.call(store.list()) as BasePornCategory[])
          .filter(category => store.topList().every(item => item.category !== category.category));
      }),
    };
  }),
  withHooks((store) => ({
    onInit() {
      store.load();
    },
  })),
);